<div class="row form-property {{property?.styleClass ? property.styleClass : ''}}">
  <div class="col-lg-12">
    <label
      class="gs-float-label {{property?.labelClass ? property.labelClass : ''}}"
      [ngClass]="{'error-color':notValid}"
      style="margin-left: 5px"
      >{{label}}</label
    >
    <div class="gs-selectbutton-wrap">
      <p-selectButton
        *ngIf="property.options"
        [options]="property.options"
        optionLabel="label"
        optionValue="value"
        [disabled]="property?.disabled ?? false"
        [(ngModel)]="value"
        (ngModelChange)="changeV($event)"
      ></p-selectButton>
    </div>
  </div>
</div>
